import request from '../_helpers/request';
import { getSubTypeMeta, getDisplayInI18nKeyFromIsCPS, matchesDisplaySectionFromIsCPS, resolveDisplayPreviewUrl } from '../pages/advertisingInfoCenter/adDisplayConfig';
var defaultDateString = '-';

/** Logo 广告无公司图时，与详情/预览一致的默认缩略图 */
export const DEFAULT_LOGO_AD_THUMB_URL = 'https://cdn.adsalecdn.com/EMP/AdvertismentInfoCenter/logoAd_default1.png?version=20250909_1635&resize,h_64,limit_1';

export const adService = {
  GetAdPSMenulistAsync
  , GetAdRecord
  , GetAdRecordList
  , GetAdDashboardStats
  , GetAdRecordDetail
  , GetAdPriorYearReuseInfo
  , ReuseAdFromPriorYear
  , SaveAdByPackageId
  , SubmitAdByPackageId
  , SaveAdDetailGroup
  , SubmitAdDetailGroup
  , groupPayloadToLegacyCheckPayload
  , AdRecordsToImageArray
  , AdRecordsToVideoArray
  , AdRecordsToProductId
  , AdRecordsToLastSaveDate
  , AdRecordsToLastSubmitDate
  , getCompanyExhibitDetails
  , saveApproval
  , AdRecordsToApprovalInfo
  , adApprove
  , AdRecordsHaveAd
  , GetPackageByCompanyId
  ,ValidateAdCustomKeyword
  ,GetSearchAdCriteriaQuota
  ,GetAdPreviewDetail
  ,GetAdStatus
  ,GetAdhotAppIds
  ,UpdateAdRejectReason
  ,refreshAdMenuBadge
  ,GetAdCheckItem
  ,GetSearchAdOptions
  ,AdRecordsToProductIdByVideo
  ,CheckAdSaveAndSubmitApi
  ,sortAdRecordsByLastSubmitDate
  ,groupAdRecordsByPageType
  ,groupAdRecordsIntoDisplayGroups
  ,getAdHeaderId
  ,isMobileAdRecord
  ,collectFormIdsFromRecords
  ,buildAdBySearchRecordsForTab
  ,dedupeAdRecordsForApproval
  ,buildAdListRows
  ,buildDetailMetaFromRecords
  ,getAdGroupLastSaveDate
  ,getAdGroupLastSubmitDate
  ,toAdDetailNavRow
  ,buildAdDetailRouteQuery
  ,buildAdDetailRouteLocation
  ,parseAdDetailRouteContext
  ,resolveAdRowStatus
  ,getAdListThumbnail
  ,isAdDraftStatus
  ,resolveAdMediaPath
  ,resolveAdProductId
  ,mapApprovalContentResults
  ,getApprovalContentResultsForAd
  ,resolveAdRejectReasonText
  ,resolveDisplayPreviewUrl
  ,SyncAdToFrontEnd
  ,parseAdDateMs
  ,hasAdListDraftIndicator
  ,getAdMediaDeviceType
};

//根据公司id 获取 该公司想配备的采购需求
function GetAdPSMenulistAsync(query) {
  return request({
    url: 'Ad/GetAdPSMenulistAsync',
    method: 'get',
    params: query
  });
}

function GetAdPreviewDetail(empCompanyId, productId) {
  return request({
    url: 'Ad/GetAdPreviewDetail',
    method: 'post',
    params: {
      compId: empCompanyId,
      productId: productId,
      LangId: localStorage.getItem('currentLangId'),
    }
  })
}

function GetAdRecord(empCompanyId, FormIds, AdPackageIds) {
  var url = 'Ad/GetAdRecord';
  var params = {
    empCompanyId: empCompanyId,
    formIds: FormIds,
    AdPackageIds: AdPackageIds,
    action: {
      LangId: localStorage.getItem('currentLangId'),
      IP: window.location.host,
      URL: window.location.href,
      Referral: document.referrer,
      BAgent: window.navigator.userAgent,
    },
  };
  return request.post(url, params)
    .then((res) => res);
}

function mapAdListRowFromApi(row) {
  if (!row) return row;
  const subType = row.subType;
  const rawLaunch = row.isLaunch ?? row.IsLaunch;
  const isLaunch = Number(rawLaunch === true || rawLaunch === '1' || rawLaunch === 1 ? 1 : 0);
  return {
    ...row,
    isLaunch,
    thumbnail: getAdListThumbnail(row),
    displayInKey: getDisplayInI18nKeyFromIsCPS(row.isCPS),
    titleKey: getSubTypeMeta(subType).titleKey,
  };
}

function hasAdListActiveFilter(options = {}) {
  return !!(
    options.displayStatus
    || options.displaySection
    || options.pageType
    || options.launchStatus
    || (options.keyword && String(options.keyword).trim())
    || options.sortField
  );
}

function getAdListStatusSortRank(row, fromAdmin = false) {
  const key = fromAdmin && row.adminDisplayStatus ? row.adminDisplayStatus : row.displayStatus;
  // 与 proc_GetAdRecordList 默认排序一致（待上架夹在审批类与已上架之间）
  const adminRank = {
    pendingManualAudit: 1,
    pending: 2,
    aiReviewing: 2,
    rejected: 3,
    toBeSubmitted: 4,
    pendingGoLive: 5,
    live: 6,
    expired: 7,
  };
  const supplierRank = {
    rejected: 1,
    toBeSubmitted: 2,
    pendingManualAudit: 3,
    pending: 4,
    aiReviewing: 4,
    pendingGoLive: 5,
    live: 6,
    expired: 7,
  };
  const rank = fromAdmin ? adminRank : supplierRank;
  return rank[key] ?? 99;
}

function sortAdListRowsDefault(rows, fromAdmin = false) {
  return [...rows].sort((a, b) => {
    const statusDiff = getAdListStatusSortRank(a, fromAdmin) - getAdListStatusSortRank(b, fromAdmin);
    if (statusDiff !== 0) return statusDiff;
    const dateA = a.lastSubmitDate && String(a.lastSubmitDate) > '1900-01-01'
      ? String(a.lastSubmitDate)
      : '';
    const dateB = b.lastSubmitDate && String(b.lastSubmitDate) > '1900-01-01'
      ? String(b.lastSubmitDate)
      : '';
    if (dateA !== dateB) return dateB.localeCompare(dateA);
    return (b.adDetailId || 0) - (a.adDetailId || 0);
  });
}

function applyAdListClientFilters(rows, options = {}, fromAdmin = false) {
  let filtered = Array.isArray(rows) ? [...rows] : [];
  const section = options.displaySection;
  if (section) {
    filtered = filtered.filter((row) => matchesDisplaySectionFromIsCPS(row.isCPS, section));
  }
  const status = options.displayStatus;
  if (status) {
    filtered = filtered.filter((row) => {
      const key = fromAdmin && row.adminDisplayStatus ? row.adminDisplayStatus : row.displayStatus;
      return key === status;
    });
  }
  const launch = options.launchStatus;
  if (launch === 'online') {
    filtered = filtered.filter((row) => Number(row.isLaunch) === 1);
  } else if (launch === 'offline') {
    filtered = filtered.filter((row) => Number(row.isLaunch) !== 1);
  }
  if (options.pageType) {
    filtered = filtered.filter((row) => row.pageType === options.pageType);
  }
  const keyword = (options.keyword || '').trim();
  if (keyword) {
    filtered = filtered.filter((row) => {
      const ids = [row.adDetailId, row.pcAdDetailId, row.mobileAdDetailId]
        .filter((id) => id != null && id !== '')
        .map(String);
      return ids.some((id) => id.includes(keyword))
        || String(row.subType || '').includes(keyword);
    });
  }
  if (options.sortField === 'effectiveDateFrom') {
    const dir = options.sortDir === 'asc' ? 1 : -1;
    filtered.sort((a, b) => dir * String(a.effectiveDateFrom || '').localeCompare(String(b.effectiveDateFrom || '')));
  } else if (options.sortField === 'lastSubmitDate') {
    const dir = options.sortDir === 'asc' ? 1 : -1;
    filtered.sort((a, b) => dir * String(a.lastSubmitDate || '').localeCompare(String(b.lastSubmitDate || '')));
  } else if (!options.sortField) {
    filtered = sortAdListRowsDefault(filtered, fromAdmin);
  }
  return filtered;
}

function summarizeAdListStats(rows) {
  const list = Array.isArray(rows) ? rows : [];
  return {
    toBeSubmittedCount: list.filter((row) => row.displayStatus === 'toBeSubmitted').length,
    liveCount: list.filter((row) => row.displayStatus === 'live').length,
    pendingCount: list.filter((row) => row.displayStatus === 'pending').length,
    rejectedCount: list.filter((row) => row.displayStatus === 'rejected').length,
    expiredCount: list.filter((row) => row.displayStatus === 'expired').length,
  };
}

function buildAdListResultFromRecords(adRecordInfos, fromAdmin, options = {}) {
  const pageIndex = options.pageIndex > 0 ? options.pageIndex : 1;
  const pageSize = options.pageSize > 0 ? options.pageSize : 10;
  const allRows = buildAdListRows(adRecordInfos, fromAdmin);
  const filtered = applyAdListClientFilters(allRows, options, fromAdmin);
  const stats = summarizeAdListStats(allRows);
  const start = (pageIndex - 1) * pageSize;
  return {
    items: filtered.slice(start, start + pageSize),
    totalCount: filtered.length,
    pageIndex,
    pageSize,
    ...stats,
    topRejectReason: null,
    topRejectDate: null,
  };
}

function GetAdRecordList(companyId, langId, fromAdmin = false, options = {}) {
  const resolvedCompanyId = Number(companyId) || 0;
  const resolvedLangId = Number(langId || localStorage.getItem('currentLangId') || 936);
  const pageIndex = options.pageIndex > 0 ? options.pageIndex : 1;
  const pageSize = options.pageSize > 0 ? options.pageSize : 10;
  const requestOptions = { ...options, pageIndex, pageSize };

  return request.post('Ad/GetAdRecordList', {
    empCompanyId: resolvedCompanyId,
    fromAdmin: !!fromAdmin,
    pageIndex,
    pageSize,
    displayStatus: options.displayStatus || '',
    displaySection: options.displaySection || '',
    pageType: options.pageType || '',
    keyword: options.keyword || '',
    sortField: options.sortField || '',
    sortDir: options.sortDir || '',
    launchStatus: options.launchStatus || '',
    action: { LangId: resolvedLangId },
  }).then(async (res) => {
    if (res.isSuccessful && res.data) {
      const payload = res.data;
      const items = Array.isArray(payload.items) ? payload.items : [];
      const totalCount = payload.totalCount || 0;
      if (
        resolvedCompanyId > 0
        && items.length === 0
        && totalCount === 0
        && !hasAdListActiveFilter(requestOptions)
      ) {
        try {
          const fallbackRes = await GetAdRecord(resolvedCompanyId, '', '');
          const infos = fallbackRes?.data?.adRecordInfos;
          if (fallbackRes?.isSuccessful && Array.isArray(infos) && infos.length > 0) {
            res.data = buildAdListResultFromRecords(infos, fromAdmin, requestOptions);
            return res;
          }
        } catch (e) {
          console.error('GetAdRecordList fallback failed', e);
        }
      }
      res.data = {
        ...payload,
        items: items.map(mapAdListRowFromApi),
      };
    }
      return res;
    });
}

function GetAdDashboardStats(companyId) {
  return request.post('Ad/GetAdDashboardStats', {
    empCompanyId: companyId,
  });
}

function refreshAdMenuBadge(companyId, store) {
  if (!companyId || !store) return Promise.resolve();
  return GetAdDashboardStats(companyId).then((res) => {
    if (res.isSuccessful && res.data) {
      store.dispatch('unread/setAdBadgeCounts', {
        toBeSubmittedCount: res.data.toBeSubmittedCount || 0,
        rejectedCount: res.data.rejectedCount || 0,
      });
    }
  });
}

function GetAdRecordDetail(companyId, langId, detail = {}) {
  return request.post('Ad/GetAdRecordDetail', buildAdRecordDetailRequest(companyId, langId, detail));
}

function UpdateAdRejectReason(companyId, approvalRequestResultId, rejectReason, langId, resultCode) {
  const resolvedLangId = langId || localStorage.getItem('currentLangId') || 936;
  const payload = {
    empCompanyId: Number(companyId) || 0,
    approvalRequestResultId: Number(approvalRequestResultId) || 0,
    rejectReason: rejectReason || '',
    action: { LangId: resolvedLangId },
  };
  if (resultCode != null && resultCode !== '') {
    payload.resultCode = String(resultCode);
  }
  return request.post('Ad/UpdateAdRejectReason', payload);
}

function mapApprovalContentResults(rows) {
  return (rows || []).map((row) => ({
    approvalRequestResultId: row.approvalRequestResultId ?? row.ApprovalRequestResultId ?? 0,
    approvalId: row.approvalId ?? row.ApprovalId ?? null,
    approvalRequestContentId: row.approvalRequestContentId ?? row.ApprovalRequestContentId ?? null,
    usageType: row.usageType ?? row.UsageType ?? '',
    usageId: row.usageId ?? row.UsageId ?? null,
    contentType: row.contentType ?? row.ContentType ?? '',
    content: row.content ?? row.Content ?? '',
    rejectReason: resolveAdRejectReasonText(row.rejectReason ?? row.RejectReason ?? ''),
    resultCode: row.resultCode ?? row.ResultCode ?? '',
    adDetailId: row.adDetailId ?? row.AdDetailId ?? 0,
    adBySearchRID: row.adBySearchRID ?? row.AdBySearchRID ?? null,
  })).filter((row) => row.approvalRequestResultId > 0);
}

/**
 * 驳回原因展示：若为 JSON（含双重转义），取 Description；否则原样返回。
 */
function resolveAdRejectReasonText(raw) {
  if (raw == null) return '';
  let text = String(raw).trim();
  if (!text) return '';
  try {
    let parsed = text;
    for (let i = 0; i < 2; i += 1) {
      if (typeof parsed !== 'string') break;
      const t = parsed.trim();
      if (!(t.startsWith('{') || t.startsWith('['))) break;
      parsed = JSON.parse(t);
    }
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      const desc = parsed.Description ?? parsed.description;
      if (desc != null && String(desc).trim() !== '') {
        return String(desc).trim();
      }
    }
  } catch (_) {
    /* 非 JSON，按原文展示 */
  }
  return text;
}

function getApprovalContentResultsForAd(results, adDetailId, adBySearchRID = null, contentType = null) {
  const detailId = Number(adDetailId) || 0;
  if (!detailId) return [];
  return (results || []).filter((row) => {
    if (Number(row.adDetailId) !== detailId) return false;
    if (contentType && row.contentType !== contentType) return false;
    if (adBySearchRID != null) {
      return Number(row.adBySearchRID) === Number(adBySearchRID);
    }
    return true;
  });
}

function GetAdPriorYearReuseInfo(companyId, langId, detail = {}) {
  return request.post('Ad/GetAdPriorYearReuseInfo', buildAdRecordDetailRequest(companyId, langId, detail));
}

function ReuseAdFromPriorYear(companyId, langId, detail = {}) {
  return request.post('Ad/ReuseAdFromPriorYear', buildAdRecordDetailRequest(companyId, langId, detail));
}

function buildAdRecordDetailRequest(companyId, langId, detail = {}) {
  const resolvedLangId = langId || localStorage.getItem('currentLangId') || 936;
  const toInt = (v) => {
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : 0;
  };
  return {
    empCompanyId: companyId,
    adDetailId: toInt(detail.adDetailId),
    adPackageId: toInt(detail.adPackageId),
    pcAdDetailId: toInt(detail.pcAdDetailId),
    pcAdPackageId: toInt(detail.pcAdPackageId),
    mobileAdDetailId: toInt(detail.mobileAdDetailId),
    mobileAdPackageId: toInt(detail.mobileAdPackageId),
    pageType: detail.pageType || '',
    includeExpired: !!detail.includeExpired,
    action: { LangId: resolvedLangId },
  };
}

function sortAdRecordsByLastSubmitDate(records) {
  if (!records || !records.length) return [];
  return [...records].sort((a, b) => {
    const dateA = (a.lastSubmitDate && a.lastSubmitDate !== '0001-01-01 00:00:00')
      ? a.lastSubmitDate
      : (a.lastSaveDate || '');
    const dateB = (b.lastSubmitDate && b.lastSubmitDate !== '0001-01-01 00:00:00')
      ? b.lastSubmitDate
      : (b.lastSaveDate || '');
    if (dateA !== dateB) return dateB.localeCompare(dateA);
    return (b.adDetailId || 0) - (a.adDetailId || 0);
  });
}

function getAdHeaderId(ad) {
  return ad?.adHeaderId ?? ad?.AdHeaderId ?? null;
}

function isMobileAdRecord(ad) {
  return !!(ad?.isMobile ?? ad?.IsMobile);
}

/**
 * PC/Mobile 成对：与 V_adPackagePageType / SQL 04·16 一致
 * — 同 PageType（同组内已保证）+ 同 subType + isMobile 相反 + 同 AdHeaderId（或无 Header 时同有效期）
 */
function resolvePcMobileAds(a, b) {
  if (isMobileAdRecord(a) && !isMobileAdRecord(b)) {
    return { pcAd: b, mobileAd: a };
  }
  if (!isMobileAdRecord(a) && isMobileAdRecord(b)) {
    return { pcAd: a, mobileAd: b };
  }
  // isMobile 缺失时不臆测，按传入顺序兜底
  return { pcAd: a, mobileAd: b };
}

function canPairPcMobileAds(a, b) {
  if (!a || !b || a.adDetailId === b.adDetailId) return false;
  if ((a.subType || '') !== (b.subType || '')) return false;
  // 必须有明确且相反的 isMobile（来自视图），不再用硬编码 packageId 表
  if (isMobileAdRecord(a) === isMobileAdRecord(b)) return false;

  const headerA = getAdHeaderId(a);
  const headerB = getAdHeaderId(b);
  if (headerA && headerB) return headerA === headerB;
  if (headerA || headerB) return false;

  return a.effectiveDateFrom === b.effectiveDateFrom
    && a.effectiveDateTo === b.effectiveDateTo;
}

/** 将同 adHeaderId + subType 的 PC/Mobile 记录合并为一条展示组 */
function groupAdRecordsIntoDisplayGroups(records) {
  const sorted = sortAdRecordsByLastSubmitDate(records || []);
  const used = new Set();
  const groups = [];

  sorted.forEach((ad) => {
    if (used.has(ad.adDetailId)) return;

    const partner = sorted.find(
      (other) => !used.has(other.adDetailId) && canPairPcMobileAds(ad, other)
    );

    if (partner) {
      const { pcAd, mobileAd } = resolvePcMobileAds(ad, partner);
      used.add(ad.adDetailId);
      used.add(partner.adDetailId);
      groups.push({
        groupKey: `${getAdHeaderId(pcAd) || pcAd.adDetailId}_${pcAd.subType}`,
        pcAd,
        mobileAd,
        primaryAd: pcAd,
        subType: pcAd.subType,
        isPaired: true,
      });
      return;
    }

    used.add(ad.adDetailId);
    const isMobile = isMobileAdRecord(ad);
    groups.push({
      groupKey: `single_${ad.adDetailId}`,
      pcAd: isMobile ? null : ad,
      mobileAd: isMobile ? ad : null,
      primaryAd: ad,
      subType: ad.subType,
      isPaired: false,
    });
  });

  return groups;
}

function resolveAdRowStatus(ad) {
  const endRaw = ad?.effectiveDateTo;
  const startRaw = ad?.effectiveDateFrom;
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (endRaw) {
    const end = new Date(endRaw);
    end.setHours(0, 0, 0, 0);
    if (!Number.isNaN(end.getTime()) && end < today) {
      return 'expired';
    }
  }
  const code = ad?.statusCode ?? ad?.StatusCode;
  if (code === 'A') {
    if (startRaw) {
      const start = new Date(startRaw);
      start.setHours(0, 0, 0, 0);
      if (!Number.isNaN(start.getTime()) && start > today) {
        return 'pendingGoLive';
      }
    }
    return 'live';
  }
  if (code === 'PA') return 'pendingManualAudit';
  if (code === 'P') return 'pending';
  if (code === 'R') return 'rejected';
  if (code === 'N' || code === '' || code == null) return 'toBeSubmitted';
  return 'toBeSubmitted';
}

function isAdDraftStatus(statusCode) {
  const code = statusCode == null ? '' : String(statusCode).trim();
  return code === '' || code === 'N' || code === 'R';
}

function parseAdDateMs(value) {
  if (value == null || value === '' || value === '-') return null;
  const raw = String(value).trim();
  if (!raw || raw.startsWith('0001-01-01') || raw.startsWith('1900-01-01')) return null;
  const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
  const ms = Date.parse(normalized);
  return Number.isNaN(ms) ? null : ms;
}

/** 列表草稿标识：仅已提交过且有新草稿时显示（未提交不显示） */
export function hasAdListDraftIndicator(row) {
  if (!row) return false;
  if (row.displayStatus === 'expired') return false;
  if (row.displayStatus === 'toBeSubmitted') return false;
  const saveMs = parseAdDateMs(row.lastSaveDate);
  const submitMs = parseAdDateMs(row.lastSubmitDate);
  if (saveMs == null || submitMs == null) return false;
  return saveMs > submitMs;
}

function resolveAdMediaPath(ad) {
  if (!ad) return '';
  const temp = ad.temp_FilePath || ad.tempFilePath || ad.temp_filePath || '';
  const real = ad.filePath || ad.FilePath || '';
  const status = ad.statusCode ?? ad.StatusCode ?? '';
  if (isAdDraftStatus(status)) return temp;
  return temp || real;
}

/** 横幅等上传类广告写入 temp_MediaFile / MediaFile 的 DeviceType：PC 或 MB */
function getAdMediaDeviceType(ad) {
  if (!ad?.isUpload) return '';
  if (ad.isMobile === true || ad.isMobile === 1) return 'MB';
  if (ad.isMobile === false || ad.isMobile === 0) return 'PC';
  return '';
}

function resolveAdProductId(ad) {
  if (!ad) return 0;
  const temp = Number(ad.temp_ProductId ?? ad.temp_productId ?? 0) || 0;
  const real = Number(ad.productId ?? ad.ProductId ?? 0) || 0;
  const status = ad.statusCode ?? ad.StatusCode ?? '';
  if (isAdDraftStatus(status)) return temp;
  return temp || real;
}

function getAdListThumbnail(ad, pageType) {
  if (!ad) return '';
  // 列表接口已按业务规则算好 thumbnail（含 videoAd 视频封面）
  const existing = ad.thumbnail && String(ad.thumbnail).trim();
  if (existing) return existing;
  const status = ad.statusCode ?? ad.StatusCode ?? '';
  let path = '';
  if (isAdDraftStatus(status)) {
    path = ad.temp_filePath || ad.temp_FilePath || ad.tempFilePath || '';
  } else {
    path = resolveAdMediaPath(ad);
  }
  if (path && String(path).trim()) return path;
  const pt = pageType || ad.pageType;
  if (pt === 'logoAd') return DEFAULT_LOGO_AD_THUMB_URL;
  return '';
}

function pickLatestRecordDate(records, ...fieldNames) {
  const dates = [];
  (records || []).forEach((record) => {
    fieldNames.forEach((field) => {
      const value = record?.[field];
      if (value && value !== '0001-01-01 00:00:00') {
        dates.push(value);
      }
    });
  });
  if (!dates.length) return defaultDateString;
  return dates.sort((a, b) => String(b).localeCompare(String(a)))[0];
}

function normalizeAdDateField(value) {
  if (!value || value === defaultDateString) return '';
  return value;
}

function getAdGroupRecords(group) {
  if (!group) return [];
  if (group.isPaired) {
    return [group.pcAd, group.mobileAd].filter(Boolean);
  }
  return group.primaryAd ? [group.primaryAd] : [];
}

function getAdGroupLastSaveDate(group) {
  return normalizeAdDateField(
    pickLatestRecordDate(getAdGroupRecords(group), 'lastSaveDate', 'LastSaveDate')
  );
}

function getAdGroupLastSubmitDate(group) {
  return normalizeAdDateField(
    pickLatestRecordDate(getAdGroupRecords(group), 'lastSubmitDate', 'LastSubmitDate')
  );
}

function buildAdListRows(adRecordInfos, fromAdmin = false) {
  const grouped = groupAdRecordsByPageType(adRecordInfos || []);
  const rows = [];
  Object.keys(grouped).forEach((pageType) => {
    groupAdRecordsIntoDisplayGroups(grouped[pageType]).forEach((group) => {
      const ad = group.primaryAd;
      if (!ad) return;
      rows.push({
        adDetailId: ad.adDetailId,
        adPackageId: ad.adPackageId ?? ad.AdPackageId ?? 0,
        pcAdDetailId: group.pcAd?.adDetailId ?? null,
        pcAdPackageId: group.pcAd?.adPackageId ?? group.pcAd?.AdPackageId ?? null,
        mobileAdDetailId: group.mobileAd?.adDetailId ?? null,
        mobileAdPackageId: group.mobileAd?.adPackageId ?? group.mobileAd?.AdPackageId ?? null,
        isPaired: !!group.isPaired,
        pageType,
        groupKey: group.groupKey,
        subType: ad.subType,
        primaryAd: ad,
        group,
        displayStatus: resolveAdRowStatus(ad),
        statusCode: ad.statusCode ?? ad.StatusCode ?? '',
        approvalId: ad.approvalId ?? ad.ApprovalId ?? null,
        effectiveDateFrom: ad.effectiveDateFrom,
        effectiveDateTo: ad.effectiveDateTo,
        lastSubmitDate: getAdGroupLastSubmitDate(group),
        lastSaveDate: getAdGroupLastSaveDate(group),
        rejectReason: ad.rejectReason ?? ad.RejectReason,
        rejectDate: ad.rejectDate ?? ad.RejectDate,
        thumbnail: getAdListThumbnail(ad, pageType),
        displayInKey: getDisplayInI18nKeyFromIsCPS(ad.isCPS),
        titleKey: getSubTypeMeta(ad.subType).titleKey,
        displayPreviewUrl: resolveDisplayPreviewUrl(ad, localStorage.getItem('currentLangId')),
      });
    });
  });
  rows.sort((a, b) => String(b.lastSubmitDate || '').localeCompare(String(a.lastSubmitDate || '')));
  return rows;
}

function buildDetailMetaFromRecords(adRecordInfos, detail = {}, fromAdmin = false) {
  const rows = buildAdListRows(adRecordInfos, fromAdmin);
  if (!rows.length) return null;
  const targetIds = new Set(
    [detail.adDetailId, detail.pcAdDetailId, detail.mobileAdDetailId]
      .map((id) => Number(id))
      .filter((id) => id > 0)
  );
  if (targetIds.size) {
    const matched = rows.find((row) =>
      [row.adDetailId, row.pcAdDetailId, row.mobileAdDetailId]
        .filter(Boolean)
        .some((id) => targetIds.has(Number(id)))
    );
    if (matched) return matched;
  }
  if (detail.pageType) {
    const byPage = rows.find((row) => row.pageType === detail.pageType);
    if (byPage) return byPage;
  }
  return rows[0];
}

function toAdDetailRouteContext(row) {
  if (!row) return null;
  const ctx = {};
  if (row.adDetailId) ctx.i = Number(row.adDetailId) || row.adDetailId;
  if (row.pageType) ctx.p = row.pageType;
  if (row.adPackageId) ctx.a = Number(row.adPackageId) || row.adPackageId;
  if (row.pcAdDetailId) ctx.pd = Number(row.pcAdDetailId) || row.pcAdDetailId;
  if (row.pcAdPackageId) ctx.pp = Number(row.pcAdPackageId) || row.pcAdPackageId;
  if (row.mobileAdDetailId) ctx.md = Number(row.mobileAdDetailId) || row.mobileAdDetailId;
  if (row.mobileAdPackageId) ctx.mp = Number(row.mobileAdPackageId) || row.mobileAdPackageId;
  if (row.titleKey) ctx.t = row.titleKey;
  if (row.displayInKey) ctx.di = row.displayInKey;
  if (row.displayStatus) ctx.s = row.displayStatus;
  if (row.subType) ctx.st = row.subType;
  if (row.lastSubmitDate) ctx.ls = row.lastSubmitDate;
  return Object.keys(ctx).length ? ctx : null;
}

function expandAdDetailRouteContext(ctx) {
  if (!ctx || typeof ctx !== 'object') return null;
  return {
    adDetailId: ctx.i ?? ctx.adDetailId ?? ctx.id ?? null,
    pageType: ctx.p ?? ctx.pageType ?? null,
    adPackageId: ctx.a ?? ctx.adPackageId ?? null,
    pcAdDetailId: ctx.pd ?? ctx.pcAdDetailId ?? null,
    pcAdPackageId: ctx.pp ?? ctx.pcAdPackageId ?? null,
    mobileAdDetailId: ctx.md ?? ctx.mobileAdDetailId ?? null,
    mobileAdPackageId: ctx.mp ?? ctx.mobileAdPackageId ?? null,
    titleKey: ctx.t ?? ctx.titleKey ?? null,
    displayInKey: ctx.di ?? ctx.displayInKey ?? null,
    displayStatus: ctx.s ?? ctx.displayStatus ?? null,
    subType: ctx.st ?? ctx.subType ?? null,
    lastSubmitDate: ctx.ls ?? ctx.lastSubmitDate ?? null,
  };
}

function base64UrlEncode(str) {
  const base64 = btoa(unescape(encodeURIComponent(str)));
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function base64UrlDecode(encoded) {
  let base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
  while (base64.length % 4) base64 += '=';
  return decodeURIComponent(escape(atob(base64)));
}

function encodeAdDetailContext(row) {
  const ctx = toAdDetailRouteContext(row);
  if (!ctx) return '';
  return base64UrlEncode(JSON.stringify(ctx));
}

function decodeAdDetailContext(encoded) {
  if (!encoded || typeof encoded !== 'string') return null;
  try {
    return expandAdDetailRouteContext(JSON.parse(base64UrlDecode(encoded)));
  } catch (e) {
    return null;
  }
}

function parseAdDetailRouteContext(route) {
  const query = route?.query || {};
  const paramId = route?.params?.adDetailId || null;
  let parsed = decodeAdDetailContext(query.ctx);
  if (!parsed && (query.pageType || query.adPackageId || query.pcAdDetailId || query.mobileAdDetailId)) {
    parsed = expandAdDetailRouteContext({
      i: paramId,
      p: query.pageType,
      a: query.adPackageId,
      pd: query.pcAdDetailId,
      pp: query.pcAdPackageId,
      md: query.mobileAdDetailId,
      mp: query.mobileAdPackageId,
    });
  }
  if (parsed) {
    if (!parsed.adDetailId && paramId) parsed.adDetailId = paramId;
    return parsed;
  }
  if (paramId) {
    return expandAdDetailRouteContext({ i: paramId });
  }
  return null;
}

function buildAdDetailRouteLocation(row) {
  const query = buildAdDetailRouteQuery(row);
  if (!query.ctx) return { name: 'AdvertismentInfoCenter' };
  return {
    name: 'AdvertismentInfoCenterDetail',
    query,
  };
}

function buildAdDetailRouteQuery(row) {
  const encoded = encodeAdDetailContext(row);
  return encoded ? { ctx: encoded } : {};
}

function toAdDetailNavRow(row) {
  if (!row) return null;
  return {
    adDetailId: row.adDetailId,
    adPackageId: row.adPackageId ?? null,
    pageType: row.pageType,
    pcAdDetailId: row.pcAdDetailId ?? null,
    pcAdPackageId: row.pcAdPackageId ?? null,
    mobileAdDetailId: row.mobileAdDetailId ?? null,
    mobileAdPackageId: row.mobileAdPackageId ?? null,
    displayStatus: row.displayStatus,
    adminDisplayStatus: row.adminDisplayStatus,
    displayInKey: row.displayInKey,
    titleKey: row.titleKey,
    lastSubmitDate: row.lastSubmitDate,
    rejectReason: row.rejectReason,
    rejectDate: row.rejectDate,
    subType: row.subType,
  };
}

function collectFormIdsFromRecords(records) {
  const ids = new Set();
  (records || []).forEach((r) => {
    String(r.formIds || r.FormIds || '')
      .split(',')
      .forEach((id) => {
        const t = id.trim();
        if (t) ids.add(t);
      });
  });
  return [...ids].join(',');
}

function mapAdBySearchRecord(f, adDetailIdOverride) {
  return {
    RID: f.rid,
    SearchType: f.searchType,
    Value: f.searchType?.toLowerCase() === 'customkeyword'
      ? (f.updateValue ?? f.text)
      : (f.updateValue ?? f.searchId),
    adDetailId: adDetailIdOverride ?? f.adDetailId,
  };
}

/** 当前 Tab 的搜索条件；Banner 等 PC/Mobile 成对时会同步 Mobile 搜索行到 PC adDetailId */
function buildAdBySearchRecordsForTab(tabRecords, allSearchRecords) {
  const detailIdSet = new Set((tabRecords || []).map((r) => r.adDetailId));
  const tabRecordByDetailId = new Map((tabRecords || []).map((r) => [r.adDetailId, r]));
  const result = [];
  const addedRids = new Set();

  const addRecord = (f, adDetailIdOverride) => {
    const ridKey = `${f.rid}_${adDetailIdOverride ?? f.adDetailId}`;
    if (addedRids.has(ridKey)) return;
    addedRids.add(ridKey);
    result.push(mapAdBySearchRecord(f, adDetailIdOverride));
  };

  (allSearchRecords || []).forEach((f) => {
    if (!detailIdSet.has(f.adDetailId)) return;
    const ad = tabRecordByDetailId.get(f.adDetailId);
    if (!ad) return;

    if (!isMobileAdRecord(ad)) {
      addRecord(f);
      (allSearchRecords || []).forEach((mb) => {
        if (mb.rid === f.rid) return;
        if (mb.searchType !== f.searchType) return;
        if (f.adHeaderId != null && mb.adHeaderId !== f.adHeaderId) return;
        const mbAd = tabRecordByDetailId.get(mb.adDetailId);
        if (!mbAd || !isMobileAdRecord(mbAd)) return;
        // 与视图一致：同 subType + PC/Mobile 相反（此处 ad 已是 PC）
        if ((ad.subType || '') !== (mbAd.subType || '')) return;
        addRecord(mb, f.adDetailId);
      });
      return;
    }

    const alreadyAddedForRid = [...addedRids].some((key) => key.startsWith(`${f.rid}_`));
    if (!alreadyAddedForRid) addRecord(f);
  });

  return result;
}

function groupAdRecordsByPageType(records, packageConfigs) {
  const map = {};
  const packagePageType = {};
  (packageConfigs || []).forEach((pkg) => {
    packagePageType[pkg.adPackageId] = pkg.pageType;
  });
  (records || []).forEach((record) => {
    const pageType = record.pageType || record.PageType || packagePageType[record.adPackageId ?? record.AdPackageId];
    if (!pageType) return;
    if (!map[pageType]) map[pageType] = [];
    map[pageType].push(record);
  });
  Object.keys(map).forEach((key) => {
    map[key] = sortAdRecordsByLastSubmitDate(map[key]);
  });
  return map;
}

function AdRecordsToLastSaveDate(AdRecords) {
  return pickLatestRecordDate(AdRecords, 'lastSaveDate', 'LastSaveDate');
}
function AdRecordsToLastSubmitDate(AdRecords) {
  return pickLatestRecordDate(AdRecords, 'lastSubmitDate', 'LastSubmitDate');
}
function AdRecordsToApprovalInfo(AdRecords) {
  var result = {
    statusCode: undefined,
    approvalDate: defaultDateString,
    rejectDate: defaultDateString,
    rejectReason: ''
  };
  if (AdRecords != undefined && AdRecords.length > 0) {
    var statusCode = AdRecords.filter(item=>['A','P','PA','R'].includes(item.statusCode))
    result.statusCode = statusCode[0]?.statusCode ? statusCode[0].statusCode : '';
    result.approvalDate = AdRecords[0].approvalDate;
    result.rejectDate = AdRecords[0].rejectDate;
    result.rejectReason = resolveAdRejectReasonText(AdRecords[0].rejectReason);

    if (result.approvalDate == '0001-01-01 00:00:00') {
      result.approvalDate = defaultDateString;
    }
    if (result.rejectDate == '0001-01-01 00:00:00') {
      result.rejectDate = defaultDateString;
    }
  }
  return result;
}

function AdRecordsToImageArray(AdRecords, adPackageId, isTemp, returnAll) {
  var result = {
    haveAd: false,
    data: []
  };
  var records = AdRecords.filter(item => item.adPackageId == adPackageId);
  records = sortAdRecordsByLastSubmitDate(records);
  if (!returnAll && records.length > 0) {
    records = [records[0]];
  }

  records.forEach((record) => {
      result.haveAd = true;
    result.effectiveDateFrom = record.effectiveDateFrom;
    result.effectiveDateTo = record.effectiveDateTo;
    result.adDetailId = record.adDetailId;
      var data = {
      imageId: record.adDetailId,
      imageName: isTemp ? record.temp_FilePath?.split('/').pop() : record.filePath?.split('/').pop(),
      imageSrc: isTemp ? record.temp_FilePath : record.filePath,
      modified: false,
      cdnLnk: isTemp ? record.temp_FilePath : record.filePath,
      adDetailId: record.adDetailId,
      adPackageId: record.adPackageId,
      effectiveDateFrom: record.effectiveDateFrom,
      effectiveDateTo: record.effectiveDateTo,
    };
      if (data.imageSrc != '' && data.imageSrc != undefined) {   
      result.data.push(data);
    }
  });

  if (result.data.length > 0) {
    const first = records[0];
    result.effectiveDateFrom = first.effectiveDateFrom;
    result.effectiveDateTo = first.effectiveDateTo;
    result.adDetailId = first.adDetailId;
  }

  return result;
}

function AdRecordsToVideoArray(AdRecords, Video_adPackageId, Cover_adPackageId, isTemp) {
  var result = {
    haveAd: false,
    data: []
  };
  var haveData = false;
  var videoData = {
    videoId: 0
    , videoSrc: ''
    , imageSrc: ''
    , modified: false
    , videoName: ''
    , videoCdnLnk: ''
    , imgCdnLnk: ''
    , FileName: ''
  };
  AdRecords.forEach(item => {
    if (item.adPackageId == Video_adPackageId) {
      result.haveAd = true;
      videoData.videoId = item.adDetailId;
      videoData.videoSrc = isTemp ? item.temp_FilePath : item.filePath;
      videoData.videoCdnLnk = isTemp ? item.temp_FilePath : item.filePath;
      result.effectiveDateFrom = item.effectiveDateFrom;
      result.effectiveDateTo = item.effectiveDateTo;
    }
    if (item.adPackageId == Cover_adPackageId) {
      result.haveAd = true;
      videoData.videoId = item.adDetailId;
      videoData.imageSrc = isTemp ? item.temp_FilePath : item.filePath;
      videoData.imgCdnLnk = isTemp ? item.temp_FilePath : item.filePath;
      result.effectiveDateFrom = item.effectiveDateFrom;
      result.effectiveDateTo = item.effectiveDateTo;
    }
  });
  if (videoData.imgCdnLnk != '' && videoData.imgCdnLnk != undefined && videoData.imageSrc != '' && videoData.imageSrc != undefined) {
    result.data.push(videoData);
  }
  return result;
}


function AdRecordsToProductId(AdRecords, adPackageId, isTemp) {
  var result = {
    haveAd: false,
    data: 0
  };
  AdRecords.forEach(item => {
    if (item.adPackageId == adPackageId) {
      result.haveAd = true;
      result.effectiveDateFrom = item.effectiveDateFrom;
      result.effectiveDateTo = item.effectiveDateTo;
      result.adDetailId=item.adDetailId
      result.data = isTemp ? item.temp_ProductId : item.productId;
    }
  });
  return result;
}
function AdRecordsToProductIdByVideo(AdRecords, adPackageId, isTemp) {
  var result = {
    haveAd: false,
    data: 0
  };
  var records = AdRecords.filter(item=>item.adPackageId == adPackageId).sort((a, b) => b.adDetailId - a.adDetailId)[0];
  if(records)
  {
    result.haveAd = true;
    result.effectiveDateFrom = records.effectiveDateFrom;
    result.effectiveDateTo = records.effectiveDateTo;
    result.adDetailId=records.adDetailId
    result.data = isTemp ? records.temp_ProductId : records.productId;  

  }
  return result;
}

function AdRecordsHaveAd(AdRecords, adPackageId) {
  if (AdRecords == null) return false;
  return AdRecords.filter(x => x.adPackageId == adPackageId).length > 0 ? true : false;
}

function buildAdActionPayload() {
  return {
    LangId: localStorage.getItem('currentLangId'),
    IP: window.location.host,
    URL: window.location.href,
    Referral: document.referrer,
    BAgent: window.navigator.userAgent,
  };
}

function groupPayloadToLegacyCheckPayload(groupPayload) {
  const items = groupPayload?.items || [];
  return {
    updateAdListParam: items.map((i) => ({
      adPackageId: i.adPackageId,
      adDetailId: i.adDetailId,
      type: i.contentType || '',
      cdnLnk: i.cdnLnk || '',
      productId: i.productId || 0,
    })),
    AdBySearchRecordsParam: groupPayload?.searchRecords || [],
  };
}

function SaveAdDetailGroup(groupPayload) {
  return request.post('Ad/SaveAdDetailGroup', {
    ...groupPayload,
    action: buildAdActionPayload(),
  }).then((res) => res);
}

function SubmitAdDetailGroup(groupPayload, istest) {
  return request.post('Ad/SubmitAdDetailGroup', {
    ...groupPayload,
    action: buildAdActionPayload(),
    istest: !!istest,
  }).then((res) => res);
}

function SaveAdByPackageId(empCompanyId, FormIds, UpdateAdByPackageIdParam,AdBySearchRecords) {
  var url = 'Ad/SaveAdByPackageId';
  var params = {
    empCompanyId: empCompanyId
    , formIds: FormIds
    , detail: UpdateAdByPackageIdParam
    ,AdBySearchRecords:AdBySearchRecords ?? []
    , action: buildAdActionPayload()
  };

  return request.post(url, params)
    .then(res => {
      return res;
    });
}
function CheckAdSaveAndSubmitApi(empCompanyId, FormIds, UpdateAdByPackageIdParam,AdBySearchRecords, istest) {
  var url = 'Ad/CheckAdSaveAndSubmitApi';
  var params = {
    empCompanyId: empCompanyId
    , formIds: FormIds
    , detail: UpdateAdByPackageIdParam
    ,AdBySearchRecords:AdBySearchRecords ?? []
    , action: buildAdActionPayload()
    , istest: istest
  };

  return request.post(url, params)
    .then(res => {
      return res;
    });
}
function SubmitAdByPackageId(empCompanyId, FormIds, UpdateAdByPackageIdParam,AdBySearchRecords, istest) {
  var url = 'Ad/SubmitAdByPackageId';
  var params = {
    empCompanyId: empCompanyId
    , formIds: FormIds
    , detail: UpdateAdByPackageIdParam
    ,AdBySearchRecords:AdBySearchRecords ?? []
    , action: buildAdActionPayload()
    , istest: istest
  };

  return request.post(url, params)
    .then(res => {
      return res;
    });
}
// export function addNotice(data) {
//     return request({
//       url: '/system/notice',
//       method: 'post',
//       data: data
//     })
// }

function getCompanyExhibitDetails(query) {
  return request({
    url: 'Ad/GetCompanyExhibitDetails',
    method: 'post',
    params: query
  });
}

function saveApproval(query) {
  return request.post('Ad/SaveApproval', query)
    .then(res => {
      return res;
    });
}

function adApprove(query) {
  return request.post('Ad/AdApprove', query)
    .then(res => {
      return res;
    });
}

function GetPackageByCompanyId(query) {
  return request({
    url: 'Ad/GetPackageByCompanyId',
    method: 'post',
    params: query
  });
}

function ValidateAdCustomKeyword(query) {
  return request({
    url: 'Ad/ValidateAdCustomKeyword',
    method: 'post',
    params: query
  });
}

function GetSearchAdCriteriaQuota(query) {
  return request({
    url: 'Ad/GetSearchAdCriteriaQuota',
    method: 'post',
    params: query
  });
}

function GetSearchAdOptions(query) {
  return request({
    url: 'Ad/GetSearchAdOptions',
    method: 'post',
    params: query
  });
}

function GetAdhotAppIds(query) {
  return request({
    url: 'Ad/GetAdhotAppIds',
    method: 'get',
    params: query
  });
}
function GetAdStatus(query) {
  return request({
    url: 'Ad/GetAdStatus',
    method: 'get',
    params: query
  });
}

function GetAdCheckItem(query) {
  return request({
    url: 'Ad/GetAdCheckItem',
    method: 'get',
    params: query
  });
}

function SyncAdToFrontEnd(data) {
  return request({
    url: 'Ad/SyncAdToFrontEnd',
    method: 'post',
    data: data
  });
}

const ONLY_ONE_AD_PACKAGE_IDS = [12, 13, 7, 15, 22, 23, 21, 24, 25, 26, 27, 28, 35, 39, 38, 37, 14, 8, 17, 11];

function dedupeAdRecordsForApproval(dataList) {
  if (!Array.isArray(dataList)) return [];
  return dataList.reduce((acc, curr) => {
    if (ONLY_ONE_AD_PACKAGE_IDS.includes(curr?.adPackageId)) {
      const existingItem = acc.find((item) => item?.adPackageId === curr?.adPackageId);
      if (!existingItem) {
        const maxData = dataList
          .filter((x) => x.adPackageId === curr.adPackageId)
          .sort((a, b) => b.adDetailId - a.adDetailId)[0];
        acc.push(maxData);
      }
    } else {
      acc.push(curr);
    }
    return acc;
  }, []);
}

